import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  orderBy,
  query,
} from "firebase/firestore";
import { db } from "../firebase";
import "./AdminApplicants.css";

function AdminApplicants() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    const q = query(collection(db, "applications"), orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);

    const list = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setApplications(list);
    setLoading(false);
  };

  const updateStatus = async (id, status) => {
    const ref = doc(db, "applications", id);
    await updateDoc(ref, { status });
    fetchApplications();
  };

  const deleteApplication = async (id) => {
    const ref = doc(db, "applications", id);
    await deleteDoc(ref);
    fetchApplications();
  };

  return (
    <div className="admin-container">
      <h1>Applicant Management</h1>

      {loading ? (
        <p>Loading applications...</p>
      ) : applications.length === 0 ? (
        <p>No applications found.</p>
      ) : (
        <div className="table-wrapper">
          <table className="app-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Job</th>
                <th>Status</th>
                <th>Resume</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {applications.map((app) => (
                <tr key={app.id}>
                  <td>{app.fullName}</td>
                  <td>{app.email}</td>
                  <td>{app.phone}</td>
                  <td>{app.jobTitle}</td>

                  <td>
                    <span className={`status ${app.status}`}>
                      {app.status || "Pending"}
                    </span>
                  </td>

                  <td>
                    {app.resumeURL && (
                      <a
                        href={app.resumeURL}
                        target="_blank"
                        rel="noreferrer"
                        className="resume-link"
                      >
                        View Resume
                      </a>
                    )}
                  </td>

                  <td className="action-buttons">
                    <button
                      className="select-btn"
                      onClick={() => updateStatus(app.id, "Selected")}
                    >
                      Select
                    </button>

                    <button
                      className="reject-btn"
                      onClick={() => updateStatus(app.id, "Rejected")}
                    >
                      Reject
                    </button>

                    <button
                      className="delete-btn"
                      onClick={() => deleteApplication(app.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminApplicants;